<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout full-height row wrap>
        <my-upload
                v-model="showImageCropper"
                langType="en"
                :noCircle="true"
                field="logo"
                @crop-success="onCropSuccess"
        ></my-upload>
        <v-dialog v-model="errorDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Error</v-card-title>
                <v-card-text>All fields are required!</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat
                            @click="errorDialog = false"
                    >Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="400px" persistent>
            <v-card>
                <v-form
                        @submit.prevent="save"
                        ref="form"
                >
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field
                                            v-model="mediaItem.name"
                                            label="Name"
                                            required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            v-model="mediaItem.website"
                                            label="Website"
                                            required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md6 align-self-center>
                                    <v-btn
                                            color="blue-grey"
                                            class="white--text button"
                                            @click="showImageCropper = true"
                                    >
                                        <v-icon left dark>cloud_upload</v-icon>
                                        Upload
                                    </v-btn>
                                </v-flex>
                                <v-flex md6 align-self-center>
                                    <v-img v-if="mediaItem.logoLink" :src="mediaItem.logoLink" :width="100"
                                           :height="100"></v-img>
                                    <span v-else><strong>No Image</strong></span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click="discard">Discard</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-flex>
            <v-btn color="primary" dark class="mb-2 button" @click="newItem">New Media</v-btn>
        </v-flex>
        <v-flex xs12>
            <v-data-table
                    :headers="headers"
                    :items="medias"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="mediaLoading"
                    class="elevation-1"
            >
                <template v-slot:items="props">
                    <td class="text-xs-left">
                        <div style="padding-top: 5px; padding-bottom: 5px">
                            <v-img :src="props.item.logoLink" :width="50" :height="50"></v-img>
                        </div>
                    </td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.website }}</td>
                    <td class="layout">
                        <v-icon
                                small
                                class="mr-2"
                                @click="editItem(props.item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                                small
                                @click="deleteItem(props.item.id)"
                        >
                            delete
                        </v-icon>
                    </td>
                </template>
                <template v-slot:no-data>
                    No medias
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapActions, mapState } from "vuex";
    import myUpload from 'vue-image-crop-upload'
    import axios from 'axios'
    import { dataURItoBlob } from '../utils/file.utils'
    import current_user from '../mixins/current_user';

    export default {
        mixins: [current_user],

        data() {
            return {
                headers: [
                    { text: 'Logo', value: 'logoLink', sortable: false },
                    { text: 'Name', value: 'name', sortable: false },
                    { text: 'Website', value: 'website', sortable: false },
                    { text: 'Actions', value: 'name', sortable: false }
                ],
                rule: [v => !!v || 'This field is required!'],
                dialog: false,
                mediaItem: {
                    id: null,
                    name: '',
                    website: '',
                    logoLink: ''
                },
                defaultItem: {
                    id: null,
                    name: '',
                    website: '',
                    logoLink: ''
                },
                showImageCropper: false,
                newImage: '',
                errorDialog: false,
                rowsPerPageItems: [50]
            }
        },

        components: {
            'my-upload': myUpload
        },
        
        methods: {
            ...mapActions('medias', [
                'saveMedia',
                'updateMedia',
                'deleteMedia',
            ]),

            deleteItem(id) {
                if (confirm('Are you sure to delete?')) {
                    this.deleteMedia(id)
                        .catch(({ response }) => {
                            if (response.data) {
                                alert(response.data.message);
                            }
                        });
                    this.$ua.trackEvent('DeleteMedia', 'click', `${this.currentUser.username || 'User'} deleted ${id}`);
                }
            },

            editItem(item) {
                this.mediaItem = Object.assign({}, item)
                this.dialog = true
            },

            save() {
                const isValid = this.validate();

                if (isValid) {
                    if (this.mediaItem.id === null) {
                        this.saveMedia(this.mediaItem)
                        this.newImage = ''
                        this.$ua.trackEvent('CreateMedia', 'click', 
                            `${this.currentUser.username || 'User'} created ${JSON.stringify(this.mediaItem, null, 2)}`);
                    } else {
                        this.updateMedia(this.mediaItem)
                        this.$ua.trackEvent('UpdateMedia', 'click',
                            `${this.currentUser.username || 'User'} updated ${this.mediaItem.id} with payload ${JSON.stringify(this.mediaItem, null, 2)}`);
                    }
                    this.dialog = false
                } else {
                    this.errorDialog = true
                }
            },

            validate() {
                const { name, website, logoLink } = this.mediaItem;
                return ( name && website && logoLink );
            },

            newItem() {
                this.mediaItem = Object.assign({}, this.defaultItem)
                this.dialog = true
            },

            onCropSuccess(imgDataUrl) {
                const formData = new FormData();
                formData.append('logo', dataURItoBlob(imgDataUrl))

                axios.post(process.env.VUE_APP_API_URL + 'media/logo', formData)
                    .then(({ data }) => {
                        this.mediaItem.logoLink = data
                        this.newImage = data
                    })
                    .catch(err => {
                        if (err) alert('Error loading image!');
                    });
            },

            discard() {
                if (
                    this.newImage !== '' &&
                    confirm("Are you sure to discard?")
                ) {
                    axios.delete(process.env.VUE_APP_API_URL + 'media/logo', 
                        { data: { logoLink: this.newImage } })
                    .then(() => {
                        this.newImage = ''
                    });
                }

                this.dialog = false
            }
        },

        computed: {
            ...mapState('medias', [ 'medias', 'mediaLoading' ]),

            formTitle() {
                return this.mediaItem.id == null ? 'New Media' : 'Edit Media'
            }
        }
    }
</script>

<style scoped>
    .button {
        margin-left: 0;
        margin-right: 0;
    }
</style>
